// extracted by mini-css-extract-plugin
module.exports = {"loader":"CssLoader_loader__3AhsZ","spin":"CssLoader_spin__2v3tf"};